import { action, computed, makeObservable, observable } from 'mobx';

import { getBrowser } from '@/utils/platform';

const CONNECTION_PROBLEM_ALERT_TIMEOUT_SECS = 3;

export class AppStore {
  connectionProblemTimeout:
    | ReturnType<typeof setTimeout>
    | 'offline'
    | undefined = undefined;

  constructor() {
    makeObservable(this, {
      connectionProblemTimeout: observable,
      hasConnectionProblem: computed,
      reportConnectionProblem: action,
      setOffline: action,
      setOnline: action,
    });

    window.addEventListener('offline', () => this.setOffline());
    window.addEventListener('online', () => this.setOnline());
  }

  get hasConnectionProblem(): boolean {
    return this.connectionProblemTimeout !== undefined;
  }

  reportConnectionProblem(): void {
    if (getBrowser() === 'Chrome') return;

    if (
      this.connectionProblemTimeout !== undefined &&
      this.connectionProblemTimeout !== 'offline'
    ) {
      clearTimeout(this.connectionProblemTimeout);
    }

    this.connectionProblemTimeout = setTimeout(
      action(() => {
        this.connectionProblemTimeout = undefined;
      }),
      1000 * CONNECTION_PROBLEM_ALERT_TIMEOUT_SECS
    );
  }

  setOffline(): void {
    this.connectionProblemTimeout = 'offline';
  }

  setOnline(): void {
    this.connectionProblemTimeout = undefined;
  }
}

export const appStore = new AppStore();
